const groups = {
    incomeTax: 'Impôt sur le revenu',
    deductions: 'Déductions d\'impôt',
    reductions: 'Réductions d\'impôt',
    credits: 'Crédits d\'impôt',
};

export default groups;
